import { render, staticRenderFns } from "./SolicitacaoMudancaHorario.vue?vue&type=template&id=ad48554c&scoped=true&"
import script from "./SolicitacaoMudancaHorario.vue?vue&type=script&lang=js&"
export * from "./SolicitacaoMudancaHorario.vue?vue&type=script&lang=js&"
import style0 from "./SolicitacaoMudancaHorario.vue?vue&type=style&index=0&id=ad48554c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad48554c",
  null
  
)

export default component.exports